








































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class RewardCoinsIcon extends Vue {
  @Prop({ default: '48' }) readonly width?: string;
  @Prop({ default: '48' }) readonly height?: string;
  @Prop({ default: '#f3b940' }) readonly fill?: string;
}
